import { PropsWithChildren, SyntheticEvent, useContext, useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, ToolbarButton, ToolbarDivider, ToolbarGroup, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
    InfoRegular
} from "@fluentui/react-icons";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { IDeleteDialogProps } from "./delete-dialog.props";
import { usePPA } from "context/ppa-context";
import { IApiError } from "@interfaces/common.interfaces";
import { getError } from "lib/utils";
import ApiErrorBar from "../api-error-bar/api-error-bar";


export default function DeleteDialog(props: IDeleteDialogProps) {
    const { t } = useL10n<ILocaleStrings>();
    const { getApiClient } = usePPA();
    const [open, setOpen] = useState<boolean>(false);
    const [apiError, setApiError] = useState<IApiError | null>(null);

    useEffect(() => {
        setOpen(props.isOpen);
    }, [props.isOpen]);

    const onOpenChange = (event: SyntheticEvent, data: { open: boolean }) => {
        props.isOpenCallback(data.open);
    }

    const onSubmit = async () => {
        setApiError(null);
        getApiClient()
            .delete(props.apiUrl)
            .then(
                (response) => {
                    //resolve(response.data);
                    props.onSuccess();
                },
                (error) => {
                    setApiError(getError(error));
                    //resolve(error);
                });
    };

    return (
        <Dialog
            modalType="alert"
            open={open}
            onOpenChange={onOpenChange}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>{props.title}</DialogTitle>
                    <DialogContent >
                        <div dangerouslySetInnerHTML={{ __html: props.message }}></div>
                        <ApiErrorBar
                            error={apiError} />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            appearance="primary"
                            onClick={onSubmit}>{t("ok")}</Button>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary">{t("cancel")}</Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}